import generalStyles from '@/components/General/Styles.module.scss';
import React, { useState } from 'react';
import API_STATES from '@/constants/StateConstants';
import { setResetPassword } from '@/services/api/csrdata.service';

function ResetPasswordOnNextLogin({email, csrPasswordChanged, csrDetails}) {
    const { status: csrDetailsStatus, error: csrDetailsError, result: csrDetailsResult = {} } = csrDetails || {};

    const [updateResetPasswordApiStatus, setUpdateResetPasswordApiStatus] = useState(API_STATES.none);
    const [updateResetPasswordApiError, setUpdateResetPasswordApiError] = useState('');

    //set resetPassword value
    async function updateChangePasswordData() {
        setUpdateResetPasswordApiStatus(API_STATES.loading);
        const result = await setResetPassword(email, !csrDetailsResult.resetPassword);
        switch (result.status) {
            case API_STATES.success:
                setUpdateResetPasswordApiStatus(API_STATES.success);
                break;
            case API_STATES.error:
                let error = result.error;
                setUpdateResetPasswordApiStatus(API_STATES.error);
                switch (error) {
                    case 401:
                        setUpdateResetPasswordApiError('CSR is not logged in.');
                        break;
                    case 403:
                        setUpdateResetPasswordApiError('Unauthorised to perform this action');
                        break;
                    case 404:
                        setUpdateResetPasswordApiError('Unable to set Reset Password - data not found');
                        break;
                    default:
                        setUpdateResetPasswordApiError('Unknown error in setting Reset Password status');
                        break;
                }
                break;
            default:
                setUpdateResetPasswordApiError('');
                setUpdateResetPasswordApiStatus(API_STATES.none);
        }
    }

    return (
        <div data-test="reset-password-component">
            {csrDetailsStatus === API_STATES.loading ? (
                <label className={generalStyles.statusMessage}>Fetching Reset Password Status</label>
            ) : csrDetailsStatus === API_STATES.error ? (
                <label className={generalStyles.errorMessage}>
                    Failed to fetch Reset Password Status: {csrDetailsError}
                </label>
            ) : (
                <>
                    <label>Reset Password on Next Login: </label>
                    <input
                        data-test="reset-password-checkbox"
                        type="checkbox"
                        checked={csrDetailsResult.resetPassword}
                        onClick={() => updateChangePasswordData()}
                        disabled={csrPasswordChanged}
                    />
                    <label data-test="reset-password-checkbox-result">
                        {updateResetPasswordApiStatus === API_STATES.loading ? (
                            <span className={generalStyles.statusMessage}>Processing...</span>
                        ) : updateResetPasswordApiStatus === API_STATES.error ? (
                            <span className={generalStyles.errorMessage}>
                                Failed to Update: {updateResetPasswordApiError}
                            </span>
                        ) : (
                            updateResetPasswordApiStatus === API_STATES.success && (
                                <span className={generalStyles.successMessage}>saved!</span>
                            )
                        )}
                    </label>
                </>
            )}
        </div>
    );
}
export default ResetPasswordOnNextLogin;
